"use strict";
exports.__esModule = true;
function getRatio() {
    return window.devicePixelRatio ? window.devicePixelRatio : 2;
}
exports["default"] = getRatio;
//# sourceMappingURL=get-ratio.js.map